import { ChevronDown } from '@aktiia/design-system';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../common';
import { IDownloadReportButtonProps } from './types';

const DownloadReportButton = forwardRef<HTMLButtonElement, IDownloadReportButtonProps>(
  ({ loading, onClick }: IDownloadReportButtonProps, ref) => {
    const { t } = useTranslation();

    return (
      <Button
        ref={ref}
        text={t('patient.button.download')}
        size="sm"
        type="tertiary"
        className="ml-auto"
        onClick={onClick}
        rightIcon={<ChevronDown className="scale-75" />}
        loading={loading}
      />
    );
  },
);
DownloadReportButton.displayName = 'DownloadReportButton';

export { DownloadReportButton };
